import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import * as api from '../../../services/api';

const MOBILE_REGEX = /^\d{10,15}$/;

const MobileStep = ({ onSuccess }) => {
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = mobile.trim();
    if (!MOBILE_REGEX.test(trimmed)) {
      setError('Enter a valid 10–15 digit mobile number');
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.requestLogin(trimmed);
      if (res.success && (res.data?.otp_sent || res.data)) {
        onSuccess(trimmed);
      } else {
        setError(res.message || 'Something went wrong');
      }
    } catch (err) {
      const res = err.response?.data;
      const code = res?.code || (err.response?.status === 401 ? 'ADMIN_NOT_FOUND' : null) || (err.response?.status === 403 ? 'ACCOUNT_SUSPENDED' : null);
      if (code === 'ADMIN_NOT_FOUND') {
        setError('No admin found for this mobile number.');
      } else if (code === 'ACCOUNT_SUSPENDED') {
        setError('This account has been suspended.');
      } else {
        setError(res?.message || err.message || 'Request failed. Please try again.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="authentication-form" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {/* <Form.Label htmlFor="login-mobile">Mobile Number</Form.Label> */}
        <Form.Control
          id="login-mobile"
          type="tel"
          inputMode="numeric"
          placeholder="Enter mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
          isInvalid={!!error}
          disabled={submitting}
          autoComplete="tel"
        />
        {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
      </Form.Group>
      <div className="mb-1 text-center d-grid">
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? 'Sending OTP…' : 'Send OTP'}
        </Button>
      </div>
    </form>
  );
};

export default MobileStep;
